import React from 'react';
import { IProcess } from '../../../../Types/ProcessModel';

interface IProps {
  process: IProcess;
}

/**
 * Inte implementerad ännu, uppdatera beskrivning när detta sker.
 */
class ProcessPage extends React.PureComponent<IProps> {
  render() {
    return (
      // <Typography>
      //   {`${this.props.process.Kod} ${this.props.process.Benamning}`}
      // </Typography>
      <div />
    );
  }
}

export default ProcessPage;
